import { computed } from '@vue/composition-api'
import store from '../../store'

const useStore = () => {

    const state = computed(() => store.state)

    return {
        state,
        store
    }
}

export default useStore